import { Button, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

export const getGroupColumn = (navigate) => [
    {
        title: "Group Name",
        dataIndex: "groupName",
        key: "groupName",
        width:"40%"
      },
      {
        title: "Created By",
        dataIndex: "creatorName",
        key: "creatorName",
        width:"40%"
      },
    
      {
      title: "Action",
      width:"8%",
      render: (_, record) => (
        <Tooltip title="View">
          <Button
            type="text"
            className="view-action-btn"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/my-groups/group-user-history/${record.groupId}`)}
          />
        </Tooltip>
      ),
    },
]